const noPhotosProvided = 'Nessuna immagine da visualizzare';
const showPhotoList = 'Mostra lista immagini';
const hidePhotoList = 'Nascondi lista immagini';

const phrases = {
  noPhotosProvided,
  showPhotoList,
  hidePhotoList,
};

export default phrases